import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'cedente' },
  {
    path: 'cedente',
    loadChildren: () =>
      import('./modules/supplier.module').then((m) => m.SupplierModule),
  },
  { path: '**', redirectTo: 'cedente' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
